export default class PartEx {
    constructor(parent) {
        this.parent = parent;
        this.client = parent.client;
        this.hashManager = parent.hashManager;
        this.myAccount2 = window.HONDA.MyAccount2; 
        this.savedValuations = { data: [] };       
        this.init();
        this.bind();
    }

    init() {
        this.fromUrl();
    }

    bind() {
        this.myAccount2?.addEventListener('login', () => this.onLogin())
    }

    onLogin() {
        this.getCarSavedValuations();
    }
    
    async getCarSavedValuations() {
        this.savedValuationsRequest = this.myAccount2.client.getCarSavedValuations();
        return await this.waitForCarSavedValuations(); 
    }

    async waitForCarSavedValuations() {
        const results = await this.savedValuationsRequest;
        const data = results?.data;
        this.pushSaved(data);
        return this.savedValuations;
    }

    fromUrl() {
        this.enabled = this.hashManager.get('partex') === 'true';
        this.id = this.hashManager.get('partex-id');
        this.finance = this.hashManager.get('partex-finance');
        this.savedValuations = this.decode();
    }

    toUrl() {
        this.hashManager.set('partex', this.enabled);
        this.hashManager.set('partex-id', this.id);
        this.hashManager.set('partex-finance', this.finance);
        this.hashManager.set('partex-data', this.encode());
        this.hashManager.update();
    }

    decode() {        
        try {
            const encoded = this.hashManager.get('partex-data');
            if(encoded) {
                const decoded = atob(encoded);
                const data = JSON.parse(decoded);
                if(data) {
                    return { data: [data] };
                }
            }
        } catch(err) { }

        return { data: [] };
    }

    encode() {
        try {
            const valuation = this.getValuationData();
            if(valuation) {
                const json = JSON.stringify(valuation);
                return btoa(json);
            }            
        } catch(err) {
            return null;
        }
    }

    getValuationData() {
        if(this.result?.valuationResponse) {
            return {
                id: this.result.valuationResponse.id,
                created: this.result.valuationResponse.created,
                data: this.result.valuationResponse,
            };
        }
    }

    pushSaved(data) {
        const items = [ ...(data ?? []) ];
        items.forEach((item) => {
            const find = this.savedValuations?.data?.find((saved) => saved.id === item.id);
            if(!find) {
                this.savedValuations?.data?.push(item);
            }
        });
    }

    reset() {
        this.enabled = false;
        this.id = null;
        this.finance = null;
        this.result = {};
        this.toUrl();
    }
}